import { useEffect, useState, type FormEvent } from "react";
import { api, type Dataset } from "../lib/api";
import { go } from "../lib/route";

export function Datasets() {
  const [datasets, setDatasets] = useState<Dataset[] | null>(null);
  const [name, setName] = useState("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void api.datasets().then(setDatasets).catch((e: Error) => setError(e.message));
  }, []);

  async function create(event: FormEvent) {
    event.preventDefault();
    try {
      const dataset = await api.createDataset(name.trim());
      setName("");
      setDatasets((current) => [dataset, ...(current ?? [])]);
      go(`/d/${dataset.id}/files`);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : String(cause));
    }
  }

  return (
    <main className="page">
      <h1>Datasets</h1>
      <p style={{ color: "var(--ink-soft)" }}>
        A dataset is one investigation's corpus. Evidence never crosses between them.
      </p>

      <form onSubmit={create} className="row" data-testid="new-dataset">
        <input
          aria-label="New dataset name"
          placeholder="New dataset name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <button className="primary" type="submit">
          Create
        </button>
      </form>

      {error && (
        <p data-testid="datasets-error" style={{ color: "var(--danger)" }}>
          {error}
        </p>
      )}

      {datasets === null && <p>loading…</p>}

      {datasets?.length === 0 && (
        <p data-testid="datasets-empty" style={{ color: "var(--ink-faint)" }}>
          Nothing here yet. Create a dataset, then upload the files you want to search.
        </p>
      )}

      <ul className="dataset-list" data-testid="dataset-list">
        {datasets?.map((dataset) => (
          <li key={dataset.id} className="card">
            <a href={`#/d/${dataset.id}`} data-testid="dataset-link">
              <strong>{dataset.name}</strong>
            </a>
            <span className="eyebrow">{dataset.role}</span>
            <p className="mono" style={{ color: "var(--ink-faint)", margin: 0 }}>
              {dataset.ingest_seq} ingest{dataset.ingest_seq === 1 ? "" : "s"}
            </p>
          </li>
        ))}
      </ul>
    </main>
  );
}
